import ModalAddEditReplacement from "./modal-add-edit-replacement";

export default ModalAddEditReplacement;